//FormManager
import React, {Component} from "react";
import PropTypes from 'prop-types';

import EventManager from "../Event/EventManager";

const defaultSettings = () => ({
    keyState:"",
});

class Field extends Component{

    constructor(props) {
        super(props);

        this.isAlive = true;
        this.event = new EventManager();

        this.settings = defaultSettings();
        for (const key in props) {
            if(this.settings.hasOwnProperty(key)){
                this.settings[key] = props[key];
            }
        }

        this.props=props;
    }


    render() {
        const {
            children,
        } = this.props;

        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.event.unbindAll();
        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}


Field.propTypes = {
    keyState: PropTypes.string,
};

Field.defaultProps = {};

export default Field

